import Component from './serial_code_used_resets.vue'
export default Component
